import { render, staticRenderFns } from "./SvgBusiness.vue?vue&type=template&id=c9c2fa90"
import script from "./SvgBusiness.vue?vue&type=script&lang=js"
export * from "./SvgBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports